import { RCBanner } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import React from 'react';
import DocumentBrandIcon from '@reverbdotcom/cadence/images/brand/document-orange.svg';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';

interface Props {
  taxType: string;
}

export function InternationalTaxIdBanner({ taxType }: Props) {
  return (
    <RCBanner
      title=""
      content={
        <Translate text="discovery.internationalTaxIds.banner.addTaxId">
          <Translate text={`discovery.internationalTaxIds.banner.${taxType}`} />
        </Translate>
      }
      image={DocumentBrandIcon}
      cta={<CoreLink to="/my/selling/tax_policy"><Translate text="discovery.internationalTaxIds.banner.buttonText" /></CoreLink>}
    />
  );
}

export default InternationalTaxIdBanner;
